import "../Styles/sass/style.scss";

import $ from "jquery";
import "../../SharedSiteCode/Scripts/shared";

import "../Components/Widgets/Hero/hero";
import "../Components/Widgets/ComparisonTable/comparison-table";
import "../FormComponents/form-fields";
import "../Components/Widgets/VideoCallout/video-modal";
import "../Components/Widgets/ZipCheckIBuyer/zip-check";

if (module.hot) module.hot.accept();
